import PropTypes from 'prop-types';
import React from 'react';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import Select from '../../../common/select';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import { t } from '../../../../modules/infra/i18n';

const getFrequency = () => [
  {
    value: 1,
    label: t('appointment:block_time.frequency.daily'),
  },
  {
    value: 7,
    label: t('appointment:block_time.frequency.weekly'),
  },
  {
    value: 14,
    label: t('appointment:block_time.frequency.weeks', { count: 2 }),
  },
  {
    value: 21,
    label: t('appointment:block_time.frequency.weeks', { count: 3 }),
  },
  {
    value: 28,
    label: t('appointment:block_time.frequency.weeks', { count: 4 }),
  },
];

const ReccuringBlockTime = ({ showFrequency, showUpdateAllRecurring, id }) => (
  <div>
    <div className="layout__item" display-if={showUpdateAllRecurring}>
      <CheckboxSwitch
        name="updateAllRecurring"
        id="updateAllRecurring"
        label={t('appointment:block_time.form.update_all_future_label')}
      />
    </div>
    <div className="layout__item" display-if={!id}>
      <CheckboxSwitch name="isRecurring" id="isRecurring" label={t('appointment:block_time.form.repeat_label')} />
      <div className="u-mt" display-if={showFrequency}>
        <div className="c-label-new">{t('appointment:block_time.form.frequency_label')}</div>
        <Select
          className="c-select"
          name="recurrEveryNumDays"
          options={getFrequency()}
          valueField="value"
          textField="label"
          empty={t('appointment:block_time.form.choose_frequency_placeholder')}
          data-automation-id="select:recurrEveryNumDays"
        />
      </div>
    </div>
  </div>
);

ReccuringBlockTime.propTypes = {
  showFrequency: PropTypes.bool.isRequired,
  showUpdateAllRecurring: PropTypes.bool,
  id: PropTypes.string,
};

ReccuringBlockTime.defaultProps = {
  showUpdateAllRecurring: false,
  id: null,
};

const selector = formValueSelector('blockTime');

const mapStateToProps = (state) => ({
  showFrequency: selector(state, 'isRecurring'),
  showUpdateAllRecurring: selector(state, 'showUpdateAllRecurring'),
  id: selector(state, 'id'),
});

export default connect(mapStateToProps)(ReccuringBlockTime);
